export default "__VITE_ASSET__CaIxusjI__"